import { resultsDuckCreator } from 'axl-ducks';

import { vdpDuckPreset } from '@/ducks/presets/index.js';

export default resultsDuckCreator({
    ...vdpDuckPreset,
    store: 'activeEmailListing',
});
